<template>
  <donut-droppable class="folder-root" @drop="onDrop">
    <div class="folder-tab b-1" :style="darkColorStyling" />
    <div class="folder-body b-1" :style="{ 'background-color': props.folder.color }" @click="onBodyClick">
      <div class="w-100p h-100p br-8" :style="lightColorStyling">
        <div class="pos-abs right-12 top-12">
          <div class="t-lg black bold ta-r">{{ props.folder.name }}</div>
          <div class="t ta-r">{{ props.folder.description }}</div>
        </div>
      </div>
      <i v-if="hasEditPermissions" class="mi md-16 folder-gear" @click.stop="onSettingsClick">settings</i>
    </div>
  </donut-droppable>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const props = defineProps({
    folder: { type: Object, required: true },
  });
  const emit = defineEmits(['open']);
  const { state, commit, dispatch } = useStore();

  const darkColorStyling = computed(() => ({
      'background-color': props.folder.color,
      filter: 'saturate(0.8) brightness(0.98)',
    }));
  const lightColorStyling = computed(() => ({
      'background-color': props.folder.color,
      filter: 'saturate(0.8) brightness(1.03)',
    }));

  const hasEditPermissions = computed(() => state.currentUser.onboarding_admin);

  const onBodyClick = () => {
    emit('open');
  };
  const onSettingsClick = () => {
    if (hasEditPermissions.value) {
      window.donut.track('Journey Folders - Edit Modal Opened', { source: 'Settings Gear', folderId: props.folder.id });
      commit('updateModal', {
        visible: true,
        subcomponent: 'onboarding-tags-modals-folder-edit',
        data: { folder: props.folder },
      });
    }
  };

  const onDrop = (dropObject) => {
    if (hasEditPermissions.value && dropObject.type === 'OnboardingTag') {
      window.donut.track('Journey Folders - Tag Dragged and Dropped', { folderId: props.folder.id, tagId: dropObject.id });
      dispatch('onboardingTagsOverview/addTagToFolder', { tag: dropObject, folder: props.folder });
    }
  };
</script>

<style scoped lang="scss">
  @import '../../../styles/donut';

  .folder-root {
    user-select: none;
    height: 146px;
    cursor: pointer;
    transition: transform 0.15s, filter 0.15s;
  }
  .folder-root:hover {
    filter: drop-shadow(0 2px 4px rgba(0,0,0, 0.10));
    transform: translateY(-2px);
  }
  .folder-root:active {
    filter: none;
    transform: translateY(0);
  }
  .folder-root.droppable-hover {
    transform: translateY(-4px);
    filter: drop-shadow(0 4px 8px rgba(0,0,0, 0.15));
  }

  .folder-tab {
    width: 40%;
    height: 16px;
    border-top-left-radius: 6px;
    border-top-right-radius: 12px;
    border-bottom: none;
  }

  .folder-body {
    position: relative;
    height: 130px;
    border-radius: 4px;
    border-top-left-radius: 0;
    padding: 16px;

    .folder-gear {
      display: none;
      position: absolute;
      bottom: 24px;
      left: 24px;
      color: $dark-gray;
    }
    .folder-gear:hover {
      color: $gray;
      transform: translateY(-2px);
    }
  }
  .folder-body:hover .folder-gear {
    display: inline;
  }
</style>
